import { useQuery } from "@tanstack/react-query";
import { Controller } from "react-hook-form";
import { z } from "zod";
import { toast } from "sonner";

import { BaseForm, FormInput } from "components/BaseForm";
import { FieldError } from "@/components/ui/field";
import RecipientService from "services/Recipient";
import RevenueOpportunityRecipientPresetService from "services/RevenueOpportunityRecipientPreset";
import RecipientSelector from "routes/revenue_opportunity_recipient_presets/components/RecipientSelector";

const schema = z.object({
  name: z.string().min(1, "Name is required"),
  recipients: z.array(z.any()).min(1, "Add at least one Recipient"),
});

const RevenueOpportunityRecipientPresetForm = ({ preset, onSuccess }) => {
  const { data: allRecipients = [] } = useQuery({
    queryKey: ["recipients", "all"],
    queryFn: async () => {
      const response = await RecipientService.getTable({ per_page: 1000 });
      const rows = response?.data || response?.rows || [];
      return rows
        .filter(r => r.enabled)
        .map(r => ({ id: r.id, name: r.name, types: r.types || [] }));
    },
  });

  const handleSubmit = async values => {
    if (preset) {
      await RevenueOpportunityRecipientPresetService.editRevenueOpportunityRecipientPreset(
        preset.id,
        values.name,
        values.recipients
      );
    } else {
      await RevenueOpportunityRecipientPresetService.createRevenueOpportunityRecipientPreset(
        values.name,
        values.recipients
      );
    }
    toast.success("Preset saved");
  };

  return (
    <BaseForm
      schema={schema}
      defaultValues={{
        name: preset?.name || "",
        recipients: preset?.info?.recipients || [],
      }}
      onSubmit={handleSubmit}
      onSuccess={onSuccess}
    >
      <FormInput name="name" label="Name" required />
      <Controller
        name="recipients"
        render={({ field, fieldState }) => (
          <div>
            <RecipientSelector
              recipients={field.value}
              setRecipients={field.onChange}
              allRecipients={allRecipients}
            />
            <FieldError>{fieldState.error?.message}</FieldError>
          </div>
        )}
      />
    </BaseForm>
  );
};

export default RevenueOpportunityRecipientPresetForm;
